import React from 'react'

import { SmallText, Title } from '../../../../components/presentation/Text'
import FlexGrid from '../../../../components/structure/FlexGrid'
import Separator from '../../../../components/helpers/Separator'
import { useAsset } from '../../_load/AssetLoader'
import { COLORS } from '@btime/constants'

const AssetPageHeader = () => {
  const asset = useAsset()

  const mountPlaceName = () => {
    if (!asset?.place) {
      return <SmallText color={COLORS.red}>{'Sem local associado'}</SmallText>
    }
    return (
      <>
        {`${asset.place.name} - ${asset.place.resume}`}
        <br />
      </>
    )
  }

  return (
    <FlexGrid direction="column" justify="flex-start" gutter={0.5}>
      <Separator weight={4} />
      <Title align="center" size="h2">
        'Olá, boas-vindas!'
      </Title>
      <SmallText align="center" maxWidth={22}>
        {'Você está acessando: '}
        <b>{asset?.name}</b>.
        <br />
        {mountPlaceName()}
        {'Em que podemos lhe ajudar?'}
      </SmallText>
      <Separator weight={6} />
    </FlexGrid>
  )
}

export default AssetPageHeader
